import axios from "./axios";

export type ScheduledUpdatePhase =
  | "announced"
  | "in_progress"
  | "completed"
  | "cancelled";

export type ScheduledUpdatePayload = {
  id: number;
  title: string;
  description: string | null;
  scheduled_at: string;
  expected_end_at: string | null;
  phase: ScheduledUpdatePhase;
  created_at: string;
  updated_at?: string;
};

export type NoticePayload = {
  id: number;
  kind: "info" | "warning";
  title: string;
  description: string | null;
  created_at: string;
  hidden_at?: string | null;
};

export type BroadcastState = {
  scheduled_update: ScheduledUpdatePayload | null;
  notices: NoticePayload[];
};

export async function fetchPlatformBroadcastState(): Promise<BroadcastState | null> {
  const res = await axios.get<{ success: boolean; data: BroadcastState }>(
    "/platform_broadcasts/state"
  );
  if (!res.data?.success) return null;
  return res.data.data;
}

export async function createScheduledUpdate(body: {
  title: string;
  description?: string;
  scheduled_at: string;
}) {
  const res = await axios.post<{ success: boolean; data: ScheduledUpdatePayload }>(
    "/platform_ops/scheduled_updates",
    { scheduled_update: body }
  );
  return res.data;
}

export async function fetchScheduledUpdatesHistory() {
  const res = await axios.get<{
    success: boolean;
    data: ScheduledUpdatePayload[];
  }>("/platform_ops/scheduled_updates");
  return res.data;
}

export async function startMaintenance(
  id: number,
  expected_end_at: string
) {
  const res = await axios.post<{ success: boolean; data: ScheduledUpdatePayload }>(
    `/platform_ops/scheduled_updates/${id}/start_maintenance`,
    { expected_end_at }
  );
  return res.data;
}

export async function confirmUpdateComplete(id: number) {
  const res = await axios.post<{ success: boolean; data: ScheduledUpdatePayload }>(
    `/platform_ops/scheduled_updates/${id}/confirm_complete`
  );
  return res.data;
}

export async function createPlatformNotice(body: {
  kind: "info" | "warning";
  title: string;
  description?: string;
}) {
  const res = await axios.post<{ success: boolean; data: NoticePayload }>(
    "/platform_ops/notices",
    { notice: body }
  );
  return res.data;
}

export async function fetchPlatformNoticesAdmin() {
  const res = await axios.get<{ success: boolean; data: NoticePayload[] }>(
    "/platform_ops/notices"
  );
  return res.data;
}

export async function updatePlatformNotice(id: number, hidden: boolean) {
  const res = await axios.patch<{ success: boolean; data: NoticePayload }>(
    `/platform_ops/notices/${id}`,
    { notice: { hidden } }
  );
  return res.data;
}
